import React from "react";
import { useLocation, useParams } from "react-router-dom";

import StudentDetailsLayout from "../../../layouts/Student";

import CoverLetterView from "../../../sub_components/student/cover-letter/CoverLetterView";

import { useGetStudentDetails } from "../../../../hooks/students";
import { useGetCareersData } from "../../../../hooks/misc";

const StudentCoverLetter = () => {
    const location = useLocation();

    const { studentId: studentIdParam } = useParams();
    const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

    const { data: student } = useGetStudentDetails(studentId);
    const { data: careersData } = useGetCareersData(studentId);

    return (
        <StudentDetailsLayout
            goBackRoute={location.state?.goBackRoute ?? null}
            operation='update'
            currentTab="Cover-Letter"
            title={student?.first_name + ' ' + student?.last_name}
            error={false}
            linkedStatus={{
                isDataAvailable: !!studentId,
                linked: !!student?.date_linked,
                linkedDate: student?.date_linked ?? null,
                unlinkedDate: student?.date_unlinked ?? null,
            }}
            isStudentAdded={!!student}
        >
            <div className="immersion__common_details__sub_info_container">
                <div className='immersion__common_details__sub_info_view'>
                    <div className="immersion__common_details__sub_info__forms_container">
                        <CoverLetterView
                            goBackRoute={location.state?.goBackRoute ?? null}
                            linked={true}
                            isLoading={false}
                            coverLetters={careersData?.cover_letters ?? []}
                        />
                    </div>
                </div>
            </div>
        </StudentDetailsLayout>
    );
};

export default StudentCoverLetter;